import React from "react";
import { Box, Button, Chip, Stack, Tooltip } from "@mui/material";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";

export default function SectionFrame({
  id,
  label,
  active,
  hidden = false,
  enabled,
  onSelect,
  onToggle,
  children,
  sx,
}) {
  const isHidden = enabled === false || hidden;

  return (
    <Box
      data-landing-section={id}
      onClick={() => onSelect(id)}
      sx={{
        position: "relative",
        opacity: isHidden ? 0.58 : 1,
        outline: active ? "3px solid rgba(243,90,58,.78)" : "1px solid transparent",
        outlineOffset: active ? -3 : 0,
        boxShadow: active ? "0 0 0 5px rgba(243,90,58,.11)" : "none",
        transition: "outline .15s ease, box-shadow .15s ease, opacity .15s ease",
        ...sx,
      }}
    >
      <Stack
        direction="row"
        spacing={0.7}
        alignItems="center"
        onClick={(event) => event.stopPropagation()}
        sx={{ position: "absolute", top: 10, right: 10, zIndex: 35 }}
      >
        <Chip
          size="small"
          label={isHidden ? `${label} · oculta` : label}
          sx={{
            bgcolor: active ? "#19242F" : "rgba(255,255,255,.95)",
            color: active ? "#fff" : "#19242F",
            fontWeight: 900,
            boxShadow: "0 5px 18px rgba(25,36,47,.12)",
          }}
        />
        {onToggle ? (
          <Tooltip title={isHidden ? `Activar ${label}` : `Desactivar ${label}`}>
            <Button
              type="button"
              size="small"
              variant="contained"
              startIcon={isHidden ? <VisibilityRoundedIcon /> : <VisibilityOffRoundedIcon />}
              onClick={() => onToggle(!isHidden)}
              sx={{
                minWidth: 0,
                borderRadius: 999,
                px: 1.15,
                py: 0.45,
                textTransform: "none",
                fontSize: 11,
                fontWeight: 950,
                bgcolor: isHidden ? "#16834b" : "rgba(25,36,47,.92)",
                boxShadow: "0 5px 18px rgba(25,36,47,.16)",
                "&:hover": { bgcolor: isHidden ? "#126d3f" : "#10171e" },
              }}
            >
              {isHidden ? "Activar" : "Ocultar"}
            </Button>
          </Tooltip>
        ) : null}
      </Stack>

      {isHidden ? (
        <Box
          aria-hidden
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 20,
            pointerEvents: "none",
            backgroundImage:
              "repeating-linear-gradient(-45deg, rgba(25,36,47,.015), rgba(25,36,47,.015) 10px, rgba(25,36,47,.045) 10px, rgba(25,36,47,.045) 20px)",
          }}
        />
      ) : null}
      {children}
    </Box>
  );
}
